import { APIError } from '@/entity/RequestManager';
import { UserBusinessPermissionFields } from '@/entity/UserBusinessPermission/UserBusinessPermission';
import UserBusinessPermissionGroup from '@/entity/UserBusinessPermissionGroup/UserBusinessPermissionGroup';
import { ElForm } from 'element-ui/types/form';
import _ from 'lodash';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SlideYUpTransition } from 'vue2-transitions';

@Component({ name: 'EditUserBusinessPermissionGroup', components: { SlideYUpTransition } })
export default class EditUserBusinessPermissionGroup extends Vue {
    private groupFormRef: ElForm;

    private groupForm = {
        name: '',
        description: '',
        permissions: []
    }

    private show = false;
    private isCreating = false;
    private permissions = ['Può modificare gli ordini', 'Può creare ordini', 'Può amministrare gli account', 'Può amministrare lo store', 'Può modificare i clienti', 'Può ricevere notifiche']
    private allChecked = false;
    private adminIsIndeterminate = true;
    private ID = '';

    private rulesGroupForm = {
        name: [{ required: true, message: 'Inserire un nome', trigger: 'change' }],
        description: [{ required: false }],
        permissions: [{ required: true, message: 'Selezionare almeno un permesso', trigger: 'change' }]
    }

    private checkboxGroupChanged() {
        const length = this.groupForm.permissions.length;

        this.allChecked = length === this.permissions.length;
        this.adminIsIndeterminate = length > 0 && length < this.permissions.length;
    }

    private adminCheckClicked(val: string) {
        this.groupForm.permissions = val ? this.permissions : [];
        this.adminIsIndeterminate = false;
    }

    private confirmClose() {
        const isChanged = false; //!_.isMatch(this.initData().groupForm, this.groupForm);

        if (isChanged) {
            this.$confirm("Ci sono modifiche non salvate, chiudere ugualmente?", "Modifiche non salvate", {
                confirmButtonText: "SÌ",
                cancelButtonText: "Annulla",
                type: "warning",
            })
                .then(() => {
                    this.closeModal();
                })
                .catch(() => {
                    return;
                });
        } else
            this.closeModal();
    }

    mounted() {
        this.groupFormRef = <ElForm>this.$refs.groupForm;
    }

    private async createGroup() {
        try {
            this.isCreating = true;

            await this.groupFormRef.validate();

            const permissions: UserBusinessPermissionFields = { canEditOrder: false, canManageAccounts: false, canManageStore: false, canEditClient: false, canReceiveNotifications: false, canCreateOrder: false };

            this.groupForm.permissions.forEach(permission => {
                if (permission == 'Può modificare gli ordini')
                    permissions.canEditOrder = true;
                else if (permission == 'Può creare ordini')
                    permissions.canCreateOrder = true;
                else if (permission == 'Può amministrare gli account')
                    permissions.canManageAccounts = true;
                else if (permission == 'Può amministrare lo store')
                    permissions.canManageStore = true;
                else if (permission == 'Può modificare i clienti')
                    permissions.canEditClient = true;
                else if (permission == 'Può ricevere notifiche')
                    permissions.canReceiveNotifications = true;
            });

            await UserBusinessPermissionGroup.update(this.ID, { name: this.groupForm.name, description: this.groupForm.description.nullIfEmpty(), permissions: permissions });

            this.closeModal();
            this.$emit('groupEdited', { ID: this.ID, name: this.groupForm.name, description: this.groupForm.description.nullIfEmpty() ?? '', permissions: permissions });
            this.$message.success({ message: 'Gruppo modificato con successo', showClose: true });
        }
        catch (error) {
            if (error instanceof APIError) {
                let message = '';

                if (error.code == 10112)
                    message = 'Nome già esistente';
                else if (error.code == 10111)
                    message = 'Valore troppo lungo';
                else
                    message = `Errore codice: ${error.code}. Contattare l'assistenza`;

                this.$message.error({ message: message, showClose: true });
                return;
            }

            this.$message.error({ message: 'Errore sconosciuto. Contattare l\'assistenza', showClose: true });
        }
        finally {
            this.isCreating = false;
        }
    }

    private closeModal() {
        this.show = false;
        this.$emit('close');
    }

    public open(group: any) {
        this.groupFormRef.resetFields();

        this.ID = '';
        this.ID = group.ID;

        this.groupForm.name = group.name;
        this.groupForm.description = group.description;

        if (group.canEditClient == 'Sì')
            this.groupForm.permissions.push('Può modificare i clienti');

        if (group.canEditOrder == 'Sì')
            this.groupForm.permissions.push('Può modificare gli ordini');

        if (group.canCreateOrder == 'Sì')
            this.groupForm.permissions.push('Può creare ordini');

        if (group.canManageAccounts == 'Sì')
            this.groupForm.permissions.push('Può amministrare gli account');

        if (group.canManageStore == 'Sì')
            this.groupForm.permissions.push('Può amministrare lo store');

        if (group.canReceiveNotifications == 'Sì')
            this.groupForm.permissions.push('Può ricevere notifiche');

        this.checkboxGroupChanged();

        this.show = true;
    }

    @Watch('show')
    private showChanged(val) {
        const documentClasses = document.body.classList;

        if (val)
            documentClasses.add('modal-open');
        else
            documentClasses.remove('modal-open');
    }
}
